import React, { useEffect } from 'react'
import Layout from '../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { saveAnnouncementList } from '../slice/announcementslice'
import { searchAnnouncement } from '../api'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { formatDateAndTime } from '../../resources/empresources/utils'
import DelAnnouncementModal from '../components/DelAnnouncementModal'
import CustomPagination from '../../../components/Pagination'

const Announcements: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [announcementId, setAnnouncementId] = React.useState<string>('')
    const [deleteForm, setDeleteForm] = React.useState(false)
    const [currentPage, setCurrentPage] = React.useState<number>(1)
    const { announcementList: rows, totalCount } = useAppSelector(
        (state: any) => state.announcements
    )
    const totalPages = Math.ceil(totalCount / 10)
    const column = [
        {
            key: 'title',
            name: 'Name',
            resizable: true,
            sortable: true,
            flexGrow: 1,
        },
        {
            key: 'locationName',
            name: 'Location',
            resizable: true,
            sortable: true,
            width: 150,
        },
        {
            key: 'for',
            name: 'For',
            resizable: true,
            sortable: true,
            width: 150,
        },
        {
            key: 'createdOn',
            name: 'Date',
            resizable: true,
            sortable: true,
            width: 200,
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            sortable: true,
            width: 100,
            renderCell: (e: any) => {
                const seenList = e.row.seenBy
                return (
                    <div className="dropdown-custom-link">
                        <Icon
                            icon="icon-park-outline:delete"
                            className="icon-secondary pointer"
                            onClick={() => {
                                setAnnouncementId(e.row.id)
                                setDeleteForm(true)
                            }}
                        />
                        <Dropdown className="ms-1">
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >
                                <Icon icon="mdi:eye" className="icon-success" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item className="disabled-dropdown-item ">
                                    <b>Seen by</b>
                                </Dropdown.Item>
                                {seenList.map((name: string, index: number) => (
                                    <Dropdown.Item
                                        key={index}
                                        className="disabled-dropdown-item "
                                    >
                                        {name}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )
            },
        },
    ]

    const loadAnnouncement = async () => {
        dispatch(SHOW_LOADER())
        try {
            const res = await searchAnnouncement({
                currentPage: currentPage,
                recordsPerPage: 10,
            })
            res?.data?.sort(
                (a: { createdOn: string }, b: { createdOn: string }) =>
                    new Date(b.createdOn).getTime() -
                    new Date(a.createdOn).getTime()
            )
            const newList = res?.data?.map((announcement: any) => {
                return {
                    ...announcement,
                    createdOn: formatDateAndTime(announcement.createdOn),
                }
            })
            dispatch(
                saveAnnouncementList({
                    data: newList,
                    totalCount: res?.totalCount,
                    currentPage: currentPage,
                })
            )
            dispatch(HIDE_LOADER())
        } catch (e) {
            dispatch(HIDE_LOADER())
            console.error(e)
        }
    }

    useEffect(() => {
        loadAnnouncement()
    }, [currentPage])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }
    return (
        <div>
            {deleteForm && (
                <DelAnnouncementModal
                    data={{ id: announcementId }}
                    onClose={setDeleteForm}
                    show={deleteForm}
                />
            )}
            <Layout custom={true}>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Announcements</h4>
                            </div>
                            <div className="col-sm-6">
                                <div className="custom-btn-design">
                                    <a
                                        onClick={() => {
                                            navigate('/announcements/create')
                                        }}
                                        className="button button-primary button-align-right"
                                    >
                                        NEW ANNOUNCEMENT
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {rows && rows?.length > 0 ? (
                        <DataGrid
                            className="data-grid-table"
                            columns={column}
                            rows={rows}
                            rowHeight={60}
                            headerRowHeight={40}
                        />
                    ) : (
                        <div className="no-records"> No records found </div>
                    )}
                    {rows?.length > 0 && (
                        <div className="mt-2">
                            <CustomPagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                getPageNumber={getCurrentPage}
                            />
                        </div>
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default Announcements
